import { useQuery } from "@tanstack/react-query";

import { getInAppPromotion } from "../../services/defs/internal-api";

/**
 * Hook to get the state of a specific in-app promotion
 * @param adKey The key identifying the ad is the promotionId
 * @returns Query result with the promotion state
 */
export const getCurrentPromotionHook = (promotionId: string, enabled: boolean = true) => {
	return useQuery({
		queryKey: ["in-app-promotion", promotionId],
		queryFn: () => getInAppPromotion(promotionId),
		enabled: enabled && !!promotionId,
		meta: {
			disableDefaultErrorHandling: true,
		},
	});
};
